import { Component } from "@angular/core";
import { NavParams, ViewController } from "ionic-angular";
import { IRegLookupResultField, IRegLookupResults } from "./results.model";
import { FormControl, FormGroup } from "@angular/forms";
import { Store } from "@ngrx/store";
import * as fromRoot from "../../../store/bootstrap";
import * as fromQueries from "../../../store/queries/queries";
import { Control } from "../../../business-objects/control/control.model";
import { isDefined } from "ionic-angular/util/util";
import { isArray } from "util";
import { ResultsModalController } from "./results-modal.controller";
import { RegLookupControlResultsModalListItem } from "./reg-lookup-control-results-modal-item.model";

@Component({
    selector: "reg-lookup-field-results-modal",
    templateUrl: "./results-modal.component.html"
})
export class ResultsModalComponent {

    results: IRegLookupResults;

    formGroupLabels: {
        [key: string]: string
    } = {};

    formGroup: FormGroup;

    items: Array<RegLookupControlResultsModalListItem>;

    constructor(protected viewController: ViewController,
                protected navParams: NavParams,
                protected controller: ResultsModalController) {
    }

    ngOnInit(): void {
        const results: IRegLookupResults = this.navParams.get("results");
        this.formGroup = this.controller.resultsToFormGroup(results);
        this.items = this.controller.getItems(this.formGroup, results);
    }

    onSubmit(): void {
        this.viewController.dismiss(this.formGroup);
    }

    onCancel(): void {
        this.viewController.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/reglookup/form/results-modal.component.ts